import { GzDialogWebComponent } from 'apps/webcomponents/src/ui/gzDialog';
import { GzDialog } from 'apps/webcomponents/src/ui/gzDialog/component/GzDialog';
import { DownloadFormWebComponent } from '../downloadForm';
import { translateFn } from '../../../utils/translator.helper';

export class DownloadDialog {
  static open(containerRef: HTMLElement): GzDialogWebComponent {
    const bodyContent: DownloadFormWebComponent = new DownloadFormWebComponent();
    const dialogConfigs: GzDialog = {
      headline: translateFn('Retrieve'),
      bodyContent,
      isOpen: true,
      isWindow: true,
    };

     return GzDialogWebComponent.buildDialogElement(dialogConfigs, containerRef);
  }
}
